import React, {Component} from 'react';
import twitter from './twitter.png';
import github from './github.png';
import development from './development.jpg';
import code from './code.jpg';
import cowboy from './cowboy.png';

class App extends Component {
  render() {
    return (
      <div className="container">
        <div className="section">
          <h1>Félix</h1>
          <h2>Lead Développeur Front</h2>
          <h3>
            Bienvenue sur ma <span className="shout">page personnelle</span>
          </h3>
        </div>
        <nav>
          <div className="menu-item">
            <a href="#experiences">Experiences</a>
          </div>
          <div className="menu-item">
            <a href="#methodologies">Méthodologies</a>
          </div>
          <div className="menu-item">
            <div className="drop-down">
              Menu déroulant<div className="drop-down-content">
                coucou !<img src={cowboy} alt="cowboy emoji" />
              </div>
            </div>
          </div>
        </nav>
        <div className="banner">
          <div className="banner-tagline">
            Demandez le meilleur pour, votre entreprise !
          </div>
        </div>
        <div className="section">
          <h1 id="experiences">Changez votre façon de voir le web</h1>
          <p>
            Developeur informatique "front end", ainsi que spécialiste
            d'Internet et passionné par ses technologies depuis plus de 10 ans.
          </p>
          <p>Je suis à votre disposition pour construire:</p>
          <ul>
            <li>vos applications,</li>
            <li>vos logiciels récalcitrants (en ligne),</li>
            <li>vos listes à puces (HTML/CSS),</li>
            <li>
              le tout avec les dernières technologies du marché (serverless,
              big data, IOT, blockchain).
            </li>
          </ul>
          <p className="illustration">
            <img src={code} alt="sample code" />
          </p>
          <h1 id="methodologies">Méthodologies à la pointe du marché</h1>

          <p>
            Mes méthodes de travail ont fait leur preuves et je peux vous les
            apporter à vous aussi:
          </p>
          <ul>
            <li>
              une compréhension approfondie du langage technique (jargon),
            </li>
            <li>interdiction des barres de défilement,</li>
            <li>
              messages de commit et noms de variables{' '}
              <span className="shout">explicites</span>
            </li>
            <li>ainsi qu'une indentation irréprochable.</li>
          </ul>

          <p className="illustration">
            <img src={development} alt="schema web design" />
          </p>
        </div>
        <div className="footer">
          <div className="column">
            <p>Copyright &copy; feelic {new Date().getFullYear()}</p>
            <p>
              <a href="./old">Consulter l'ancienne version du site</a>
            </p>
          </div>
          <div className="column">
            <p>Retrouvez moi les réseaux sociaux:</p>
            <ul>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://twitter.com/feelic"
                >
                  {' '}
                  <img
                    className="social-icon"
                    src={twitter}
                    alt="twitter logo"
                  />{' '}
                  Tweeeter
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://github.com/feelic"
                >
                  {' '}
                  <img
                    className="social-icon"
                    src={github}
                    alt="github logo"
                  />{' '}
                  Github
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js